<template>
  <!-- parent controls visibility via v-if and passes `vcn` object -->
  <div class="nested-modal-overlay" v-if="vcn">
    <div class="nested-modal-content">
      <div class="modal-header">
        <h3>Upload Files for M. V. <sapn style="color: blue;">{{ vcn.VesselName }}</sapn> Voy
          <span style="color: blue;">{{ vcn.import_voyageName == null ? vcn.export_voyageName : vcn.import_voyageName }}</span>
          At <span style="color: blue;">{{ vcn.area }}</span>
        </h3>
        <button class="close-btn" @click="close">&times;</button>
      </div>
      <div class="modal-body">
        <div>
          <div class="form-group">
            <div class="form-item">
              <label for="partyname">Party *</label>
              <select id="partyname" v-model="selectedShortName" style="width:100%">
                <option value="">Select Party</option>
                <option v-for="party in linkParties" :key="party.autoid" :value="party.autoid">
                  {{ party.short_name }}
                </option>
              </select>
            </div>
            <div class="form-item">
              <label for="onFileChange">Select File(s) *</label>
              <input type="file" @change="onFileChange" ref="fileAdd" class="btn btn-default" multiple style="width:100%" />
            </div>
            <div class="form-item">
              <button class="save-button" @click="uploadFiles" style="margin-top: 20px;">Upload</button>
            </div>
          </div>
        </div>
        <div v-if="UploadFilesList.length > 0">
          <table class="vcns-table">
            <thead>
              <tr>
                <th>Party</th>
                <th>No of image</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in UploadFilesList" :key="index">
                <td>{{ item.short_name }}</td>
                <td>{{ item.no_of_file }}</td>
                <td><i class="fas fa-image image-icon" @click="showOverlay(item.vcnID, item.partyId)" title="View Image"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          No Files uploaded.
        </div>
      </div>
      <div class="modal-footer">
        <button class="cancel-button" @click="close">Close</button>
      </div>
    </div>

    <!-- file/image overlay -->
    <div v-if="fileoverlayVisible" class="overlay">
      <div class="overlay-content" style="width:80%; max-width:1000px;">
        <!-- Hidden file inputs accept image and pdf files -->
        <input type="file" ref="addImageInput" style="display:none" @change="onAddImageChange" accept="image/*,.pdf" multiple />
        <input type="file" ref="replaceImageInput" style="display:none" @change="onReplaceImageChange" accept="image/*,.pdf" />

        <!-- Preview Area -->
        <div v-if="currentImage" style="width:100%; ">
          <!-- Image Preview -->
          <img v-if="isImage(currentImages[currentIndex].filename)" :src="currentImage" style="max-width:100%;max-height:600px" />
          <!-- PDF Preview -->
          <iframe v-else-if="isPdf(currentImages[currentIndex].filename)" :src="currentImage" width="100%" height="400"></iframe>
          <!-- Controls -->
          <div style="margin-top:10px">
            <button class="nav-button left" @click="prevImage" :disabled="currentIndex === 0" style="background: transparent;">
              <i class="fa fa-arrow-circle-left" style="font-size:36px"></i>
            </button>
            <button class="nav-button right" @click="nextImage" :disabled="currentIndex === currentImages.length - 1" style="background: transparent;">
              <i class="fa fa-arrow-circle-right" style="font-size:36px"></i>
            </button>
          </div>
        </div>
        <div class="no-image" v-else>No images. Click <strong>＋ Add</strong> to upload.</div>

        <!-- Bottom toolbar -->
        <div class="overlay-toolbar">
          <span class="image-counter" v-if="currentImages.length > 0">{{ currentIndex + 1 }} / {{ currentImages.length }}</span>
          <button class="overlay-action-btn add-img-btn" @click="triggerAddImage" title="Add Image(s)">＋ Add</button>
          <button class="overlay-action-btn replace-img-btn" v-if="currentImages.length > 0" @click="triggerReplaceImage" title="Replace Current Image">✎ Replace</button>
          <button class="overlay-action-btn delete-img-btn" v-if="currentImages.length > 0" @click="deleteCurrentImage" title="Delete Current Image">🗑 Delete</button>
          <button class="overlay-action-btn close-img-btn" @click="closeOverlay">X Close</button>
        </div>
      </div>
    </div>

    <!-- delete confirmation -->
    <div v-if="isDeleteImageConfirmVisible" class="edit-overlay" style="z-index:10001">
      <div class="edit-overlay-content" style="width:35%;">
        <h2>Confirm Delete</h2>
        <p>Are you sure you want to delete this image?</p>
        <div class="form-buttons" style="margin-top:12px;">
          <button type="button" class="save-button" @click="confirmDeleteImage">Yes, Delete</button>
          <button type="button" class="cancel-button" @click="isDeleteImageConfirmVisible = false">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';

export default {
  name: 'UploadFilesModal',
  props: {
    vcn: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      linkParties: JSON.parse(localStorage.getItem('party')) || [],
      selectedShortName: "",
      imagefiles: [],
      UploadFilesList: [],
      fileoverlayVisible: false,
      currentImage: '',
      currentIndex: 0,
      currentImages: [],
      selectedPartyId: null,
      isDeleteImageConfirmVisible: false,
      applicantID: 0,
      accountID: 0,
      partyname: '',
    };
  },
  watch: {
    vcn(newVal) {
      if (newVal) {
        this.fetchFilesForVCN(newVal.vcnID);
      }
    }
  },
  mounted() {
    if (this.vcn) {
      this.fetchFilesForVCN(this.vcn.vcnID);
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onFileChange(e) {
      var selectedFiles = e.target.files;
      for (var i = 0; i < selectedFiles.length; i++) {
        this.imagefiles.push(selectedFiles[i]);
      }
    },
    async uploadFiles() {
      const partyId = this.selectedShortName;
      const vcnId = this.vcn.vcnID;
      if (partyId == 0 || partyId == null || partyId == "") {
        useToast().error('Please select party to upload files');
        return;
      }
      if (!this.imagefiles || this.imagefiles.length === 0) {
        useToast().error('Please select at least one file to upload.');
        return;
      }
      const party = this.linkParties.find(party => party.autoid === this.selectedShortName);
      if (party) {
        this.applicantID = party.applicantId
        this.accountID = party.accountId
        this.partyname = party.short_name
      }

      const data = new FormData();
      const fileInput = this.$refs.fileAdd;
      for (const file of fileInput.files) {
        data.append("files", file);
      }
      const transactionData = {
        partyId: partyId,
        vcnId: vcnId,
        applicantID: this.applicantID,
        accountID: this.accountID,
        partyname: this.partyname,
        vcnName: this.vcn.vcnName,
        CreateDate: this.vcn.CreateDate,
        VesselName: this.vcn.VesselName,
        import_voyageName: this.vcn.import_voyageName,
        export_voyageName: this.vcn.export_voyageName,
      };
      const x = JSON.stringify(transactionData);
      data.append('transaction', x);
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          }
        };
        await axios.post('/upload_files_vcn_party', data, config);
        this.imagefiles = [];
        useToast().success('Files uploaded successfully.');
        await this.fetchFilesForVCN(vcnId);
      } catch (error) {
        console.error('Error uploading files:', error);
        useToast().error('An error occurred while uploading files.');
      }
    },
    async fetchFilesForVCN(vcnId) {
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        };
        const response = await axios.get(`/get_vcn_files?vcnid=${vcnId}`, config);
        this.UploadFilesList = response.data[2] || [];
      } catch (error) {
        console.error('Error fetching uploaded files:', error);
        useToast().error('An error occurred while fetching uploaded files.');
      }
    },
    async showOverlay(vcnID, partyId) {
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        const responce = await axios.get('/get_vcn_files_by_party_vcn?vcnID=' + vcnID + '&partyId=' + partyId, config);
        this.selectedPartyId = partyId;
        this.currentImages = responce.data[2];
        this.currentIndex = 0;
        this.fileoverlayVisible = true;

        if (this.currentImages.length > 0) {
          const config2 = {
            headers: {
              'accept': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            responseType: 'blob'
          };
          const folderpath = this.currentImages[0]['folderpath'];
          const filename = this.currentImages[0]['filename'];
          const imagepath = folderpath + '/' + filename;
          const imageRes = await axios.get('/ConvertImageToBlob?filename=' + imagepath, config2);
          this.currentImage = URL.createObjectURL(imageRes.data);
        } else {
          this.currentImage = '';
        }
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
      this.$nextTick(() => {
        document.querySelector('.overlay').classList.add('overlay-active');
      });
    },
    async reloadOverlayImages(vcnID, partyId) {
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        const responce = await axios.get('/get_vcn_files_by_party_vcn?vcnID=' + vcnID + '&partyId=' + partyId, config);
        this.selectedPartyId = partyId;
        this.currentImages = responce.data[2];
        if (this.currentImages.length === 0) {
          this.currentImage = '';
          this.currentIndex = 0;
          return;
        }
        if (this.currentIndex >= this.currentImages.length) {
          this.currentIndex = this.currentImages.length - 1;
        }
        if (this.currentImages.length > 0) {
          const config2 = {
            headers: {
              'accept': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            responseType: 'blob'
          };
          const folderpath = this.currentImages[0]['folderpath'];
          const filename = this.currentImages[0]['filename'];
          const imagepath = folderpath + '/' + filename;
          const imageRes = await axios.get('/ConvertImageToBlob?filename=' + imagepath, config2);
          this.currentImage = URL.createObjectURL(imageRes.data);
        } else {
          this.currentImage = '';
        }
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    },
    async loadImage(index) {
      const token = localStorage.getItem("access_token");
      const config = {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${token}`
        },
        responseType: "blob"
      };
      const folderpath = this.currentImages[index]['folderpath'];
      const filename = this.currentImages[index]['filename'];
      const imagepath = folderpath + '/' + filename;
      const imageRes = await axios.get('/ConvertImageToBlob?filename=' + imagepath, config);
      this.currentImage = URL.createObjectURL(imageRes.data);
    },
    nextImage() {
      if (this.currentIndex < this.currentImages.length - 1) {
        this.currentIndex++;
        this.loadImage(this.currentIndex);
      }
    },
    async triggerAddImage() {
      this.$refs.addImageInput.click();
    },
    async triggerReplaceImage() {
      this.$refs.replaceImageInput.click();
    },
    async deleteCurrentImage() {
      this.isDeleteImageConfirmVisible = true;
    },
    async confirmDeleteImage() {
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        const image = this.currentImages[this.currentIndex];
        const info = {
          auto_id: image.auto_id,
          imagepath: image.filename,
          vcnID: this.vcn.vcnID
        };
        const data = new FormData();
        data.append('imageInfo', JSON.stringify(info));
        const response = await axios.post('/delete_vcn_party_image', data, config);
        if (response.data[0] === 1) {
          useToast().success('Image deleted successfully');
          await this.reloadOverlayImages(this.vcn.vcnID, this.selectedPartyId);
        } else {
          useToast().error(response.data[1] || 'Failed to delete image');
        }
      } catch (error) {
        useToast().error('Error deleting image');
        console.error(error);
      }
      this.isDeleteImageConfirmVisible = false;
    },
    async onAddImageChange(e) {
      const files = e.target.files;
      if (!files.length) return;
      const token = localStorage.getItem('access_token');
      const data = new FormData();
      const party = this.linkParties.find(party => party.autoid === this.selectedPartyId);

      const info = JSON.stringify({
        vcnID: this.vcn.vcnID,
        CreateDate: this.vcn.CreateDate,
        vcnName: this.vcn.vcnName,
        VesselName: this.vcn.VesselName,
        import_voyageName: this.vcn.import_voyageName,
        export_voyageName: this.vcn.export_voyageName,
        applicantID: party.applicantId,
        accountID: party.accountId,
        partyname: party.short_name,
        partyId: this.selectedPartyId
      });
      data.append('transaction', info);
      for (const file of files) {
        data.append('files', file);
      }
      try {
        const response = await axios.post('/add_new_image_for_vcn_party', data, {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${token}` }
        });
        if (response.data[0] === 0) {
          useToast().error(response.data[1]);
        } else {
          useToast().success('Image(s) added successfully');
          await this.reloadOverlayImages(this.vcn.vcnID, this.selectedPartyId);
        }
      } catch (error) {
        useToast().error('Error adding image');
        console.error(error);
      }
      e.target.value = '';
    },
    async onReplaceImageChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      const token = localStorage.getItem('access_token');
      const data = new FormData();
      const party = this.linkParties.find(party => party.autoid === this.selectedPartyId);
      const info = JSON.stringify({
        vcnID: this.vcn.vcnID,
        CreateDate: this.vcn.CreateDate,
        vcnName: this.vcn.vcnName,
        VesselName: this.vcn.VesselName,
        import_voyageName: this.vcn.import_voyageName,
        export_voyageName: this.vcn.export_voyageName,
        applicantID: party.applicantId,
        accountID: party.accountId,
        partyname: party.short_name,
        partyId: this.selectedPartyId,
        auto_id: this.currentImages[this.currentIndex]['auto_id'],
        imagepath: this.currentImages[this.currentIndex]['filename'],
      });
      data.append('transaction', info);
      data.append('file', file);
      try {
        const response = await axios.post('/replace_image_for_vcn_party', data, {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${token}` }
        });
        if (response.data[0] === 0) {
          useToast().error(response.data[1]);
        } else {
          useToast().success('Image replaced successfully');
          await this.reloadOverlayImages(this.vcn.vcnID, this.selectedPartyId);
        }
      } catch (error) {
        useToast().error('Error replacing image');
        console.error(error);
      }
      e.target.value = '';
    },
    prevImage() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.loadImage(this.currentIndex);
      }
    },
    isImage(file) {
      return /\.(jpg|jpeg|png|gif|webp)$/i.test(file);
    },
    isPdf(file) {
      return /\.pdf$/i.test(file);
    },
    closeOverlay() {
      this.currentImages = [];
      this.selectedPartyId = null;
      document.querySelector('.overlay').classList.remove('overlay-active');
      this.fileoverlayVisible = false;
    }
  }
};
</script>

<style scoped>
/* shared form/modal styles copied from UserDashboard.vue */
.dashboard {
  padding: 20px;
}

.form-group {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 5px;
}

.form-item {
  width: 30%;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  width: 95%;
  max-width: 1400px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  /* make it a positioned container so nested overlay can be absolute inside */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.modal-body {
  padding: 16px;
  /* fixed height for modal content area to keep header/footer visible
     and make the content scrollable. Use max-height as a safety for
     small screens so it never exceeds viewport. */
  height: 600px;
  max-height: 75vh;
  overflow: scroll;
  display: flex;
  flex-direction: column;
}

.modal-footer {
  padding: 12px 16px;
  border-top: 1px solid #eee;
  text-align: right;
}

.close-btn {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

.vcns-table {
  width: 100%;
  border-collapse: collapse;
}

.vcns-table th,
.vcns-table td {
  padding: 8px 10px;
  border: 1px solid #eee;
  text-align: left;
}

.vcns-table th {
  background: #f5f5f5;
}

.search-input {
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  width: 360px;
  max-width: 60%;
}

.search-inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-label {
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}

.cancel-button {
  padding: 8px 12px;
  border-radius: 4px;
  border: none;
  background: #6c757d;
  color: #fff;
  cursor: pointer;
}

.edit-button {
  padding: 6px 10px;
  border-radius: 4px;
  border: none;
  background: #007bff;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
}

.edit-button:hover {
  background: #0056b3;
}

.save-button {
  padding: 8px 12px;
  border-radius: 4px;
  border: none;
  background: #28a745;
  color: #fff;
  cursor: pointer;
}

.save-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* styles moved from UserDashboard.vue for upload modal and overlay */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out;
}

.overlay-active {
  opacity: 1;
  visibility: visible;
}

.overlay-content {
  position: relative;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  max-width: 80vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: scale(0.9);
  transition: transform 0.3s ease-in-out;
}

.overlay-active .overlay-content {
  transform: scale(1);
}

.overlay-content img {
  max-width: 70vw;
  max-height: 70vh;
  object-fit: contain;
}

.nav-button {
  background-color: #fff;
  border: none;
  font-size: x-large;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

.nav-button:hover {
  transform: scale(1.2);
}

.left {
  position: absolute;
  left: -5px;
  top: 50%;
  transform: translateY(-50%);
}

.right {
  position: absolute;
  right: -5px;
  top: 50%;
  transform: translateY(-50%);
}

.no-image {
  padding: 30px 20px;
  text-align: center;
  color: #555;
  font-style: italic;
}

/* Nested modal (renders on top of a parent modal's content) */
.nested-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  /* sits above modal content */
}

.nested-modal-content {
  background: #fff;
  width: 95%;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}
.edit-overlay {
  position: fixed;
  /* Ensures the overlay stays above all other content */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  /* Enables scrolling if the content exceeds viewport height */
  z-index: 9999;
  /* Ensures it appears above all other content */
}

/* Overlay content */
.edit-overlay-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  /* Adjusted width for better fit */
  /*max-width: 1000px;*/
  /* Adjusted max-width */
  max-height: 90vh;
  /* Limits the height to prevent overflow */
  overflow-y: auto;
  /* Enables vertical scrolling within the content */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: relative;
  margin-top: 50px;
  /* Adds margin from the top */
}
/* toolbar buttons */
.overlay-action-btn {
  border: none;
  border-radius: 4px;
  padding: 5px 12px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: opacity 0.2s;
}

.overlay-action-btn:hover {
  opacity: 0.8;
}

.add-img-btn {
  background-color: #28a745;
  color: #fff;
}

.replace-img-btn {
  background-color: #007bff;
  color: #fff;
}

.delete-img-btn {
  background-color: #dc3545;
  color: #fff;
}

.close-img-btn {
  background-color: #807d7d;
  color: #fff;
}
.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.overlay-action-btn {
  border: none;
  border-radius: 4px;
  padding: 5px 12px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: opacity 0.2s;
}

.overlay-action-btn:hover {
  opacity: 0.8;
}
</style>